export default __webpack_public_path__ + "static/Reel_Commercial_British-07f01d804ac80b7879b17aa7f276fd93.mp3";